// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"dcec13e5","74":"c529c648","161":"e2d1b7d3","246":"31a33aaa","285":"a62c42bd","358":"770c8862","500":"48501605","549":"60a7de42","705":"8ee0f13d","758":"8fed38cb","920":"a8675f4f"}[chunkId] + ".chunk.js";
};